import { useMutation } from '@tanstack/react-query';

export default function useCompanyTagUnchain() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ companyId, tagId }: { companyId: number; tagId: number }) => {
      const response = await fetch(`/agent/api/company_tags/${companyId}/unchain`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({ company_tag: { id: tagId } }),
      });
      if (!response.ok) {
        throw new Error(`Failed to unchain company tag: ${response.status}`);
      }
      const data = await response.json();
      return data;
    },
  });
}
